import script from "./ViewNextTick.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewNextTick.vue?vue&type=script&setup=true&lang=js"

import "./ViewNextTick.vue?vue&type=style&index=0&id=2e449aef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e449aef"]])

export default __exports__